import { NgFor, NgIf } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Fitter } from '@sc/data-access-models';
import { FeatureFlippingManagerService } from '@sc/feature-flipping';
import { ScreenUtils } from '@sc/utils';
import { FitterCommentComponent } from '../fitter-comment';
import { FitterInfosBoxComponent } from '../fitter-infos-box';
import { IconComponent } from '../icon';
import { RatingComponent } from '../rating';

@Component({
  selector: 'sc-fitter-comments-sheet',
  styleUrls: ['./fitter-comments-sheet.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [
    NgIf,
    NgFor,
    IconComponent,
    RatingComponent,
    FitterInfosBoxComponent,
    FitterCommentComponent,
    TranslateModule,
  ],
  template: `
    <div class="container">
      <div *ngIf="showCloseBtn" class="close">
        <button type="button" class="close-btn" (click)="onClose()">
          <span class="sr_only">{{
            'GlobalApplicativeConstants.accessibility.closeDialog'
              | translate: { dialogTitle: 'Fitter.customerReviews' | translate }
          }}</span>
          <sc-icon name="close"></sc-icon>
        </button>
      </div>

      <div class="comments-header">
        <h1
          class="section-title"
          id="fitter-comments-title-id"
          mat-dialog-title
        >
          {{ 'Fitter.customerReviews' | translate }}
        </h1>
        <sc-rating
          [rating]="fitter?.google?.rating"
          [showNumberRating]="true"
          [numberRating]="fitter?.google?.review?.length"
          [brandId]="fitter?.brandId"
        ></sc-rating>
      </div>

      <sc-fitter-infos-box
        *ngIf="isMobileResolution()"
        [fitter]="fitter"
        [itineraryDistanceInMeters]="itineraryDistanceInMeters"
        [itineraryDurationInSeconds]="itineraryDurationInSeconds"
      ></sc-fitter-infos-box>

      <div class="fitter-comments" *ngIf="fitter.google?.review">
        <div class="fitter-comments-wrapper">
          <sc-fitter-comment
            class="fitter-comment"
            *ngFor="let review of fitter.google?.review"
            [review]="review"
            [compact]="false"
            [sliceText]="false"
          ></sc-fitter-comment>
        </div>
      </div>
    </div>
  `,
})
export class FitterCommentsSheetComponent {
  @Input() fitter: Fitter;
  @Input() itineraryDistanceInMeters = 0;
  @Input() itineraryDurationInSeconds = 0;
  @Input() showCloseBtn = true;

  @Output() closeEvent = new EventEmitter<void>();

  isMobileResolution = ScreenUtils.isMobileResolution;

  constructor(public featureFlippingService: FeatureFlippingManagerService) {}

  onClose() {
    this.closeEvent.emit();
  }
}
